import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=53ab88be&scoped=true"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"
import style0 from "./UserList.vue?vue&type=style&index=0&id=53ab88be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab88be",
  null
  
)

export default component.exports